import React from 'react';
import { Card, Row, Col, Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { 
  ExperimentOutlined, 
  SearchOutlined, 
  BuildOutlined, 
  BarChartOutlined,
  UserSwitchOutlined,
  ExperimentFilled
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export default function AntibodyPage() {
  const navigate = useNavigate();

  const analysisModules = [
    {
      key: 'sequence',
      title: '抗体编号与CDR查找',
      description: '抗体序列编号、CDR识别',
      icon: <ExperimentOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
      path: '/antibody/sequence',
      features: ['抗体编号', 'CDR识别', '批量处理'],
      available: true
    },
    {
      key: 'humanization',
      title: '抗体人源化',
      description: '抗体人源化分析与优化',
      icon: <UserSwitchOutlined style={{ fontSize: '32px', color: '#722ed1' }} />,
      path: '/antibody/humanization',
      features: ['人源化分析', '人源化建议', '亲和力预测', '可视化对比'],
      available: false
    },
    {
      key: 'epitope',
      title: '表位预测',
      description: 'B细胞表位预测和抗原表位分析',
      icon: <SearchOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
      path: '/antibody/epitope',
      features: ['B细胞表位预测', '线性表位识别', '构象表位分析', '多种预测模式'],
      available: true
    },
    {
      key: 'structure',
      title: '结构预测',
      description: '抗体三维结构预测',
      icon: <BuildOutlined style={{ fontSize: '32px', color: '#fa8c16' }} />,
      path: '/antibody/structure',
      features: ['抗体结构预测', '3D可视化'],
      available: true
    },
    {
      key: 'propermab',
      title: '可开发性预测',
      description: '基于Propermab的抗体分子特征和可开发性预测',
      icon: <BarChartOutlined style={{ fontSize: '32px', color: '#eb2f96' }} />,
      path: '/antibody/propermab',
      features: ['分子特征计算', '可开发性评估', '理化性质分析', '聚集倾向预测'],
      available: false
    },
    {
      key: 'viscosity',
      title: '粘度预测',
      description: '基于DeepViscosity的抗体粘度类别预测',
      icon: <ExperimentFilled style={{ fontSize: '32px', color: '#f5222d' }} />,
      path: '/antibody/viscosity',
      features: ['粘度类别预测', '批量预测支持', '深度学习模型', '高低粘度分类'],
      available: true
    }
  ];

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
      <div style={{ textAlign: 'center', marginBottom: 48 }}>
        <Title level={1}>抗体CDR查找</Title>
        <Paragraph style={{ fontSize: '16px', color: '#666' }}>
          提供抗体序列CDR查找功能
        </Paragraph>
      </div>

      <Row gutter={[24, 24]}>
        {analysisModules.map((module) => (
          <Col xs={24} sm={12} lg={6} key={module.key}>
            <Card
              hoverable={module.available}
              style={{ 
                height: '100%',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                cursor: module.available ? 'pointer' : 'not-allowed',
                transition: 'all 0.3s ease',
                opacity: module.available ? 1 : 0.6
              }}
              bodyStyle={{ padding: '32px' }}
              onClick={() => module.available && navigate(module.path)}
            >
              <div style={{ textAlign: 'center', marginBottom: 24 }}>
                {module.icon}
                <Title level={3} style={{ marginTop: 16, marginBottom: 8 }}>
                  {module.title}
                  {!module.available && (
                    <span style={{ 
                      fontSize: '12px', 
                      color: '#999', 
                      marginLeft: '8px',
                      fontWeight: 'normal'
                    }}>
                      (即将上线)
                    </span>
                  )}
                </Title>
                <Paragraph style={{ color: '#666', marginBottom: 24 }}>
                  {module.description}
                </Paragraph>
              </div>
              <div style={{ marginBottom: 24 }}>
                <Title level={5} style={{ marginBottom: 12 }}>主要功能：</Title>
                <ul style={{ paddingLeft: 20, margin: 0 }}>
                  {module.features.map((feature, index) => (
                    <li key={index} style={{ marginBottom: 4, color: '#666' }}>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}